<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2022-05-26 16:22:11
 * @LastEditors: mrh
 * @LastEditTime: 2022-05-27 16:04:58
-->
<template>
  <div class="tables">
    <div>
      <p>第三方公司名称</p>
      <p>使用SDK名称</p>
      <p class="message">涉及个人信息</p>
      <p>使用场景</p>
      <p>使用目的</p>
      <!-- <p>共享方式</p> -->
      <p class="link">第三方链接</p>
    </div>
    <p>
      <span>友盟同欣（北京）科技有限公司</span>
      <span>友盟分享</span>
      <span class="message"
        >设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM卡IMSI/ICCID/地理位置等）、应用列表</span
      >
      <span>分享商品、店铺主页</span>
      <span>为用户提供内容分享至第三方平台功能</span>
      <!-- <span>SDK本机采集</span> -->
      <span class="link"
        >隐私政策链接：<a href="https://www.umeng.com/page/policy"
          >https://www.umeng.com/page/policy</a
        ></span
      >
    </p>
    <p>
      <!-- <span style="border-bottom: none;" class="centens"> -->
        <span>
          北京百度网讯科技有限公司
        </span>
      <!-- </span> -->
      <span>百度定位SDK</span>
      <span class="message"
        >设备信息【包括设备标识信息（Android ID、IDFA、IDFV）、系统信息（操作系统版本、设备品牌及型号、设备配置）和应用信息（应用名）</span
      >
      <span>推荐商品模块获取定位筛选商品</span>
      <span>为最终用户提供定位功能及服务</span>
      <!-- <span>SDK本机采集</span> -->
      <span class="link">隐私政策链接：
          <a href="https://lbs.baidu.com/index.php?title=openprivacy">https://lbs.baidu.com/index.php?title=openprivacy</a>
      </span>
    </p>
    <p>
      <!-- <span style="border-top: none;"></span> -->
      <span>北京百度网讯科技有限公司</span>
      <span>百度地图SDK</span>
      <span class="message"
        >设备信息（包括Android ID、IDFV、操作系统版本、设备品牌及型号、设备配置、应用信息（应用名）、陀螺仪角度）</span
      >
      <span>用户注册时选择所在位置</span>
      <span>为最终用户提供地图展示和搜索、步骑行导航功能及服务</span>
      <!-- <span>SDK本机采集</span> -->
      <span class="link"
        >百度隐私政策链接：
        <a href="https://lbs.baidu.com/index.php?title=openprivacy">https://lbs.baidu.com/index.php?title=openprivacy</a>
        </span>
    </p>
    <!-- <p>
      <span>北京百度网讯科技有限公司</span>
      <span>百度地图</span>
      <span class="message">位置信息</span>
      <span>首页：根据您当前位置，获取当前地区下的备课数据</span>
      <span>为最终用户提供地图展示和搜索、步骑行导航功能及服务</span>
      <span class="link"
        >百度隐私政策链接：
        <a href="https://lbs.baidu.com/index.php?title=openprivacy">https://lbs.baidu.com/index.php?title=openprivacy</a>
        </span>
    </p> -->
    <p>
      <span>腾讯科技（深圳）有限公司</span>
      <span>微信开放平台</span>
      <span class="message">设备标识信息（Android ID）、设备参数及系统信息（设备型号、操作系统）、网络相关信息（IP地址、网络运营商）、已安装应用包名信息</span>
      <span>用户使用微信账号授权登录时；用户分享内容至微信客户端时</span>
      <span>为用户提供第三方账号登录、内容分享功能</span>
      <!-- <span>SDK本机采集</span> -->
      <span class="link"
        >腾讯隐私政策链接:
            <a href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8">https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a>
      </span>
    </p>
    <p>
      <span>阿里云计算有限公司</span>
      <span>上传SDK</span>
      <span class="message">UUID、设备型号、IP地址</span>
      <span>上传视频</span>
      <span>实现快捷视频、音频、图片、字母等各种媒体文件到点播存储的服务</span>
      <!-- <span>SDK本机采集</span> -->
      <span class="link" style="height:auto;"
        >隐私政策链接:
            <a href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112151438_20307.html">https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112151438_20307.html</a>
      </span>
    </p>
    <p>
      <span>友盟同欣（北京）科技有限公司</span>
      <span>友盟统计分析 SDK</span>
      <span class="message">设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM 卡 IMSI 信息等</span>
      <span>用户行为数据、App 运营数据的采集与可视化分析</span>
      <span>提供用户行为数据、App 运营数据的采集与可视化分析，帮助更好的分析决策实现业务增长</span>
      <!-- <span>SDK本机采集</span> -->
      <span class="link" style="height:auto;"
        >隐私政策链接:
            <a href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a>
      </span>
    </p>
    <p>
      <span>友盟应用性能监控平台U-APM SDK</span>
      <span>设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM卡IMSI/ICCID/地理位置等 SDK</span>
      <span class="message">App稳定性监控， 崩溃问题追踪</span>
      <span>App稳定性监控， 崩溃问题追踪</span>
      <span>提供App稳定性监控， 崩溃问题追踪服务</span>
      <!-- <span>SDK本机采集</span> -->
      <span class="link" style="height:auto;"
        >隐私政策链接:
            <a href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.tables {
  display: table-cell;
  > div {
    display: flex;
    font-size: 14px;
    > p {
      width: 200px;
      padding: 10px;
      text-align: center;
      border: 1px solid #d9d9d9;
    }
  }
  > p {
    font-size: 14px;
    display: flex;
    > span {
      width: 200px;
      padding: 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #d9d9d9;
      position: relative;
      span {
        position: absolute;
        top: 60px;
        left: 10px;
        z-index: 99;
      }
    }
  }
  .message {
    width: 300px;
  }
  .link {
    width: 500px;
    flex-wrap: wrap;
  }
  .centens {
  }
}
</style>
